module.exports = __webpack_public_path__ + "img/In suite dining.3166f4ec.jpeg";